import { render, staticRenderFns } from "./TheForm.vue?vue&type=template&id=5275d350&scoped=true&"
import script from "./TheForm.vue?vue&type=script&lang=ts&"
export * from "./TheForm.vue?vue&type=script&lang=ts&"
import style0 from "./TheForm.vue?vue&type=style&index=0&id=5275d350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275d350",
  null
  
)

export default component.exports